import { Box } from "@mui/material"
import React, { useContext } from "react"
import useWidth from "../utils/useWidth"

import { UserTypeContext } from "../context/userStatus"

import { setOpenSubscriptionModal } from "../store/actions/userTypeAction"
import CommonTypo from "./CommonTypo"
import NewButton from "./NewButton"
import { pxToRem } from "../theme/typography"


const RestrictedWidget = () => {

    const width = useWidth()
    const isMobile = width < 768
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    console.log("IUserTypeState.planProducts", IUserTypeState.planProducts)
    const onClose = () => {
        userTypeDispatch(setOpenSubscriptionModal(true))
    }

    const getImage = () => {
        return "/paymentfailed.png"
    }

    return <Box display={"flex"} alignItems={"center"} gap={"32px"} padding={"16px 12px"}>
        <Box sx={{
            width: isMobile ? "100%" : "540px",
            borderRadius: "12px 12px 0px 0px",
            overflow: "hidden"
        }}>
            <img src={getImage()} alt="payment-logo" style={isMobile ? {
                width: "100%",
                height: "156px",
                objectFit: "cover",
                borderRadius: "12px 12px 0px 0px",
                objectPosition: "center 75%"
            } : {
                width: "540px",
                height: "200px",
                objectFit: "cover",
                borderRadius: "12px",
                objectPosition: "center 50%"
            }} />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"16px"} >
            <Box display={"flex"} flexDirection={"column"} gap={"8px"} >
                <CommonTypo size={24} fontWeight={700} lineHeight={28} color="var(--color-text-primary)">This feature is available on paid plans only</CommonTypo>
                <CommonTypo size={16} fontWeight={400} lineHeight={24} color="var(--color-text-secondary)">Upgrade to unlock all the features</CommonTypo>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={"8px"} >
                <NewButton
                    buttonText={<>
                        <CommonTypo size={16} lineHeight={24} fontWeight={600} color="var(--color-text-primary)">Upgrade Plan</CommonTypo>
                    </>}
                    onClick={onClose}
                    extraSx={{
                        width: "max-content",
                        background: "var(--color-new-main)",
                        border: `none`,
                        height: "42px",
                        padding: "8px 16px !important",
                        borderRadius: "12px !important",
                        "&:hover": {
                            background: "var(--color-new-main)",
                            boxShadow: "none"
                        }
                    }}
                    boxSx={{
                        padding: 0
                    }}
                    typographySx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        "&.MuiTypography-root": {
                            "@media  (max-width: 726px) and (min-width: 100px)": {
                                fontSize: `${pxToRem(16)} !important`,
                                lineHeight: "100% !important",
                                fontWeight: 600,
                                color: "var(--color-text-primary)"
                            },
                        },
                    }}
                />
            </Box>
        </Box>
    </Box>
}

export default RestrictedWidget
